import React from 'react';
import Explore from 'components/modules/master/Explore';
import { useFlags } from 'launchdarkly-react-client-sdk';
function UnifiedViewFlagWrapper(props) {
    const flags = useFlags();
    const unifiedViewV2 = flags === null || flags === void 0 ? void 0 : flags.unifiedViewV2;
    return React.createElement(Explore, Object.assign({}, props, { unifiedViewV2: unifiedViewV2 }));
}
export default UnifiedViewFlagWrapper;
